import React from 'react'
import { Button, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Paper, Typography } from '@mui/material'
import { blueGrey, grey } from '@mui/material/colors'

export type JmaAlertMessageProps = {
  heading: string
  color: string
  title: string
  area: string
  message: string
  date: string
}

export const JmaAlertMessage = ({heading, color, title, area, message, date}: JmaAlertMessageProps) => {
  const [open, setOpen] = React.useState(false)

  return (
    <>
      <Paper sx={{backgroundColor: blueGrey[800], m: 1, p: 1, cursor: 'pointer'}} elevation={2} square onClick={() => setOpen(true)}>
        <Chip label={heading} size='small' sx={{backgroundColor: color, color: 'white', fontSize: 10, height: 20}} />
        <Typography variant='body2' color={grey[50]} mt={1}>{title}</Typography>
        <Typography variant='caption' color={grey[400]} mt={1}>{area}</Typography>
        <Typography textAlign='right' component='div' variant='caption' color={grey[400]}>{date}</Typography>
      </Paper>

      <Dialog
        open={open}
        onClose={() => {setOpen(false)}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle variant='h6'>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText whiteSpace={'pre-line'} fontSize={14}>
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
